<script setup lang="ts">
// PROPS
interface Props {
    salesContact?: SalesContact;
}

defineProps<Props>();

// MODEL
const isModalOpen = defineModel<boolean>('open', { required: true });

// COMPOSABLES
const { isMobile } = useResponsive();
const { tt } = useTypedI18n();

// DATA
const salesContactFormModalState = useModalState<boolean>();
</script>

<template>
    <UModal
        v-model:open="isModalOpen"
        :fullscreen="isMobile"
        :title="tt('vas.LogisticsService.alternativeTransportModal.title')"
        v-bind="modalNoDescAriaFixupProps"
    >
        <template #body>
            <div class="space-y-4">
                <p>{{ tt('vas.LogisticsService.alternativeTransportModal.description') }}</p>

                <SalesContactCard v-if="salesContact" :sales-contact="salesContact" @open-contact-form="salesContactFormModalState.open()" />
            </div>
        </template>
    </UModal>

    <SalesContactFormModal
        v-if="salesContact"
        v-model="salesContactFormModalState.isOpen"
        :sales-contact="salesContact"
        @success="salesContactFormModalState.confirm(true)"
    />
</template>
